/**
 * Same-origin transport names for the short-lived Google Meet OAuth callback.
 *
 * The state is minted by the backend and PKCE verifier stays exclusively in
 * the initiating portal component's memory. This name carries neither value
 * and is not persisted by the browser.
 */
export const GOOGLE_MEET_OAUTH_MESSAGE_TYPE = "lms-google-meet-oauth";

export function googleMeetOAuthChannelName(state: string): string {
  return `lms-google-meet-oauth:${state}`;
}

export type GoogleMeetOAuthMessage = {
  type: typeof GOOGLE_MEET_OAUTH_MESSAGE_TYPE;
  state?: unknown;
  code?: unknown;
  error?: unknown;
};
